export default function PHP_MySQLUpdate() {
  return (
    <div>
      <h1>PHP_MySQLUpdate</h1>
    </div>
  );
}
